"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.StopwatchTimer = void 0;

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _msToTime = require("../../../../common/msToTime");

var _mobx = require("mobx");

var _class, _descriptor, _descriptor2, _descriptor3, _temp;

var StopwatchTimer = (_class = (_temp =
/*#__PURE__*/
function () {
  function StopwatchTimer(splitMilliseconds, lapMilliseconds) {
    var _this = this;

    if (splitMilliseconds === void 0) {
      splitMilliseconds = 0;
    }

    if (lapMilliseconds === void 0) {
      lapMilliseconds = 0;
    }

    (0, _initializerDefineProperty2.default)(this, "milliseconds", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "splitMilliseconds", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "savedMilliseconds", _descriptor3, this);
    (0, _mobx.runInAction)(function () {
      _this.splitMilliseconds = splitMilliseconds;
      _this.milliseconds = splitMilliseconds - lapMilliseconds;
    });
  }

  var _proto = StopwatchTimer.prototype;

  _proto.saveTime = function saveTime() {
    this.savedMilliseconds += this.milliseconds;
    this.milliseconds = 0;
  };

  _proto.reset = function reset() {
    this.milliseconds = this.savedMilliseconds = 0;
  };

  (0, _createClass2.default)(StopwatchTimer, [{
    key: "totalMilliSeconds",
    get: function get() {
      return this.milliseconds + this.savedMilliseconds;
    }
  }, {
    key: "displayLap",
    get: function get() {
      return (0, _msToTime.msToTime)(this.totalMilliSeconds);
    }
  }, {
    key: "displaySplit",
    get: function get() {
      return (0, _msToTime.msToTime)(this.splitMilliseconds);
    }
  }]);
  return StopwatchTimer;
}(), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "milliseconds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "splitMilliseconds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "savedMilliseconds", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "saveTime", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveTime"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "totalMilliSeconds", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalMilliSeconds"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displayLap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayLap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "displaySplit", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "displaySplit"), _class.prototype)), _class);
exports.StopwatchTimer = StopwatchTimer;